import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { FORMAZIONI } from "../lib/data";

const Formazioni = () => {
  const marqueeItems = ["Solista", "Duo", "Trio", "Quartetto", "Ensemble", "Orchestra", "Coro", "Voce"];

  return (
    <section
      id="formazioni"
      className="relative py-28 md:py-40 bg-pw overflow-hidden"
      data-testid="formazioni-section"
    >
      {/* Marquee top */}
      <div className="overflow-hidden border-y border-[var(--pw-border)] py-6 mb-20">
        <div className="marquee-track">
          {[...marqueeItems, ...marqueeItems, ...marqueeItems].map((m, i) => (
            <span
              key={i}
              className="font-serif italic text-4xl md:text-6xl text-[var(--pw-text)]/15 whitespace-nowrap select-none"
            >
              {m} <span className="text-[var(--pw-gold)]/50">✦</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="gold-line" />
            <span className="overline">Formazioni Musicali</span>
            <span className="gold-line" />
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--pw-text)] max-w-4xl mx-auto">
            Dal <em className="text-[var(--pw-gold)]">solista</em> all'orchestra:
            la formazione perfetta per ogni scena.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FORMAZIONI.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Music;
            return (
              <motion.div
                key={f.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="card-pw p-8 group"
                data-testid={`formazione-${f.name.toLowerCase()}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon
                    size={32}
                    className="text-[var(--pw-gold)] group-hover:rotate-12 transition-transform duration-500"
                    strokeWidth={1.2}
                  />
                  <span className="font-serif italic text-[var(--pw-text)]/30 text-2xl">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif font-light text-3xl text-[var(--pw-text)]">
                  {f.name}
                </h3>
                <p className="mt-4 text-[var(--pw-text)]/65 font-light text-[15px] leading-relaxed">
                  {f.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Formazioni;
